import { render, staticRenderFns } from "./ReplaceDocument.vue?vue&type=template&id=c0ea02ae&scoped=true"
import script from "./ReplaceDocument.vue?vue&type=script&lang=js"
export * from "./ReplaceDocument.vue?vue&type=script&lang=js"
import style0 from "./ReplaceDocument.vue?vue&type=style&index=0&id=c0ea02ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ea02ae",
  null
  
)

export default component.exports